import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="footer bg-white text-dark py-4">
      <Container>
        <Row className="text-center">
          <Col md={6}>
            <p className="mb-0">© {new Date().getFullYear()} CORSIA</p>
          </Col>
          <Col md={6}>
            <p className="mb-0">
              <a href="/privacy-policy" className="text-primary">Privacy Policy</a> | 
              <a href="/terms-and-conditions" className="text-primary"> Terms and Conditions</a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;